import React from 'react'
import { format } from 'date-fns'
import { cn } from '@/utils/ui'

interface EventDateProps {
  date: string
  className?: string
}

export const EventDate: React.FC<EventDateProps> = ({ date, className }) => {
  if (!date) return null

  const dateObj = new Date(date)
  const month = format(dateObj, 'MMM')
  const day = format(dateObj, 'dd')

  return (
    <div className={cn('flex flex-col items-center justify-center min-w-[28px]', className)}>
      <span className="text-label-XS-regular text-text-faded mb-1">{month}</span>
      <span
        className="text-text-base text-headline-S-semibold leading-[100%] tracking-[-0.24px]"
        style={{ fontSize: '24px' }}
      >
        {day}
      </span>
    </div>
  )
}
